<template>
  <mdb-row>
    <mdb-col col="sm">
      <mdb-jumbotron class="mb-0 p-3 text-break">
        <h1 class="display-6">


          <span v-html="title"></span>

          <span v-if="showAvailabilityIcon" class="d-inline-block slot-availability"
                :class="{'slot-available' : isAvailable}"></span>
        </h1>
        <p class="lead" v-html="subtitle"></p>
      </mdb-jumbotron>
    </mdb-col>
  </mdb-row>
</template>

<script>
export default {
  name: 'Jumbotron',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    showAvailabilityIcon: {
      type: Boolean,
      required: false,
      default: false
    },
    isAvailable: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>

.jumbotron {
  box-shadow: none;
  background-color: transparent;

  h1 {
    font-weight: 500;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/partials/Jumbotron.vue